import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { api } from 'helpers/axios';
import { errorMessage } from 'helpers/common';
import * as Sentry from "@sentry/react";

const fetchInterviewsSettings = createAsyncThunk('fetchInterviewsSettings', async (_, { getState, rejectWithValue }) => {
  try {
    const { data, status } = await api.get('/settings/interviews');
    if (status === 200) return data;
  } catch (err) {
    Sentry.captureException(err);
    return rejectWithValue(errorMessage(err, 'fetch interviews settings'));
  }
});

export const interviewsSettingsSlice = createSlice({
  name: 'interviewsSettings',
  initialState: {
    dataActive: null,
    dataAll: null,
    complaintEnabled: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInterviewsSettings.fulfilled, (state, action) => {
        const allData = action.payload.data;
        const activeData = allData.filter(d => d.is_active);
        activeData.sort((a, b) => a.rank - b.rank);
        allData.sort((a, b) => a.rank - b.rank);

        state.dataActive = activeData;
        state.dataAll = allData;
        state.complaintEnabled = action.payload.meta.complaint_enable;
      });
  }
});

export const getInterviewsSettings = (state) => state.interviewsSettings.dataActive;
export const getAllInterviewsSettings = (state) => state.interviewsSettings.dataAll;
export const getComplaintEnabled = (state) => state.interviewsSettings.complaintEnabled;

export { fetchInterviewsSettings };

export default interviewsSettingsSlice.reducer;
